import { render, staticRenderFns } from "./CMMJComponent.vue?vue&type=template&id=60b56364&scoped=true"
import script from "./CMMJComponent.vue?vue&type=script&lang=ts"
export * from "./CMMJComponent.vue?vue&type=script&lang=ts"
import style0 from "./CMMJComponent.vue?vue&type=style&index=0&id=60b56364&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b56364",
  null
  
)

export default component.exports